import { render, staticRenderFns } from "./PriorityAssessmentNotice.vue?vue&type=template&id=0388753e&"
import script from "./PriorityAssessmentNotice.vue?vue&type=script&lang=js&"
export * from "./PriorityAssessmentNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports